import React,{
  useEffect,
  useRef,
  useState
} from "react";

import GoogleLiveMap from "../../components/GoogleLiveMap";
import API from "../../api/api";

import { FiPackage } from "react-icons/fi";

import {
  Autocomplete,
  GoogleMap,
  Marker,
  DirectionsRenderer,
  useJsApiLoader
} from "@react-google-maps/api";

const libraries = ["places"];

export default function CustomerCreateOrder({
  pickupLocation,
  setPickupLocation,

  dropoffLocation,
  setDropoffLocation,

  itemNotes,
  setItemNotes,

  pickupSuggestions,
  setPickupSuggestions,

  dropoffSuggestions,
  setDropoffSuggestions,

  searchLocations,
  calculateDistance,

  distance,
  amount,
  deliveryTime,
  weatherSurcharge,
  weatherCondition,

  paymentMethod,
  setPaymentMethod,

  momoNumber,
  setMomoNumber,

  showConfirm,
  setShowConfirm,

  createOrder,

 pickupCoords,
 dropoffCoords
}) {

 const pickupRef = useRef(null);
const dropoffRef = useRef(null);

const [availableRiders,setAvailableRiders] =
  useState([]);

useEffect(()=>{

  async function fetchAvailableRiders(){

    try{

      const res =
        await API.get(
          "/rider/available-map"
        );

      setAvailableRiders(
        res.data?.riders || []
      );

    }catch(err){

      console.log(
        "AVAILABLE RIDERS MAP ERROR:",
        err.response?.data || err.message
      );
    }
  }

  fetchAvailableRiders();

  const interval =
    setInterval(
      fetchAvailableRiders,
      5000
    );

  return ()=>clearInterval(interval);

},[]);

const {
  isLoaded
} = useJsApiLoader({
  googleMapsApiKey:
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries
});   

if(showConfirm){

  return (
    <>

      <div
        style={{
          background:"linear-gradient(135deg,#ffffff,#f8fafc)",
          borderRadius:"22px",
          padding:"22px",
          boxShadow:"0 12px 28px rgba(15,23,42,0.07)",
          border:"2px solid #facc15",
          marginTop:"10px"
        }}
      >
        <button
          type="button"
          onClick={()=>setShowConfirm(false)}
          style={{
            border:"none",
            borderRadius:"12px",
            padding:"10px 14px",
            background:"#f1f5f9",
            color:"#0f172a",
            fontWeight:"900",
            cursor:"pointer",
            marginBottom:"18px"
          }}
        >
          ← Back
        </button>

        <h2
          style={{
            fontSize:"24px",
            marginBottom:"14px",
            color:"#0f172a",
            display:"flex",
            alignItems:"center",
            gap:"10px",
            fontWeight:"900"
          }}
        >
          <span
            style={{
              width:"24px",
              height:"24px",
              borderRadius:"12px",
              display:"inline-flex",
              alignItems:"center",
              justifyContent:"center",
              background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
              color:"#facc15",
              fontSize:"14px"
            }}
          >
            <FiPackage />
          </span>

          Confirm Your Order
        </h2>

        <ConfirmRow label="Pickup" value={pickupLocation} />
        <ConfirmRow label="Dropoff" value={dropoffLocation} />
        <ConfirmRow label="Item Notes" value={itemNotes || "None"} />
        <ConfirmRow label="Distance" value={`${distance} KM`} />
        <ConfirmRow label="Estimated Delivery Time" value={deliveryTime} />
        <ConfirmRow label="Delivery Fee" value={`₵${amount}`} />

        <ConfirmRow
          label="Payment Method"
          value={
            paymentMethod === "cash"
            ? "Cash on Delivery"
            : paymentMethod === "momo"
            ? "Mobile Money"
            : "Not selected"
          }
        />

        {paymentMethod === "momo" && (
          <ConfirmRow
            label="MoMo Number"
            value={momoNumber}
          />
        )}

        <div
          style={{
            display:"flex",
            gap:"10px",
            marginTop:"18px",
            flexWrap:"wrap"
          }}
        >
          <button
            type="button"
            onClick={createOrder}
            style={{
              border:"none",
              borderRadius:"14px",
              padding:"12px 16px",
              background:"#2563eb",
              color:"white",
              fontWeight:"900",
              cursor:"pointer",
              touchAction:"manipulation",
              WebkitTapHighlightColor:"transparent",
              userSelect:"none",
              flex:1
            }}
          >
            Confirm Order
          </button>

          <button
            type="button"
            onClick={()=>setShowConfirm(false)}
            style={{
              border:"none",
              borderRadius:"14px",
              padding:"12px 16px",
              background:"#dc2626",
              color:"white",
              fontWeight:"900",
              cursor:"pointer",
              touchAction:"manipulation",
              WebkitTapHighlightColor:"transparent",
              userSelect:"none",
              flex:1
            }}
          >
            Cancel
          </button>
        </div>
      </div>

    </>
  );
}

return (
  <>
    <div
      style={{
        background:"linear-gradient(135deg,#ffffff,#f8fafc)",
        borderRadius:window.innerWidth <= 480 ? "16px" : "22px",
        padding:window.innerWidth <= 480 ? "12px" : "18px",
        border:"1px solid rgba(29,78,216,0.10)",
        boxShadow:"0 10px 24px rgba(15,23,42,0.06)",
        position:"relative",
        overflow:"hidden"
      }}
    >
      <div
        style={{
          background:
            "radial-gradient(circle at top right, rgba(250,204,21,0.30), transparent 32%), linear-gradient(135deg,#0f172a,#1d4ed8)",
          borderRadius:window.innerWidth <= 480 ? "14px" : "20px",
          padding:window.innerWidth <= 480 ? "12px" : "18px",
          marginBottom:window.innerWidth <= 480 ? "12px" : "18px",
          color:"white",
          border:"1px solid rgba(250,204,21,0.22)",
          boxShadow:"0 10px 24px rgba(29,78,216,0.16)"
        }}
      >
        <div
          style={{
            display:"inline-flex",
            padding:window.innerWidth <= 480 ? "5px 10px" : "6px 12px",
            borderRadius:"999px",
            background:"rgba(250,204,21,0.18)",
            color:"#facc15",
            border:"1px solid rgba(250,204,21,0.35)",
            fontSize:window.innerWidth <= 480 ? "11px" : "12px",
            fontWeight:"900",
            marginBottom:window.innerWidth <= 480 ? "7px" : "10px"
          }}
        >
          🚀 Fast Delivery Across Accra
        </div>

        <h2
          style={{
            fontSize:window.innerWidth <= 480 ? "19px" : "24px",
            fontWeight:"900",
            lineHeight:"1.12",
            margin:"0 0 6px",
            color:"white"
          }}
        >
          Send Packages Faster, Safer & Smarter 📦
        </h2>

        <p
          style={{
            maxWidth:"570px",
            color:"rgba(255,255,255,0.86)",
            fontSize:window.innerWidth <= 480 ? "12px" : "13px",
            fontWeight:"600",
            lineHeight:"1.35",
            margin:0
          }}
        >
          Book a rider, track your delivery, and pay with ease —
          all from your MB Swift dashboard.
        </p>
      </div>
        <OrderSection
          step="1"
          title="Pickup Location"
        >
          {isLoaded ? (
  <Autocomplete
  options={{
    componentRestrictions:{
      country:"gh"
    },
    fields:[
      "formatted_address",
      "geometry",
      "name"
    ]
  }}
  onLoad={(autocomplete)=>{
    pickupRef.current = autocomplete;
  }}
    onPlaceChanged={()=>{
      const place =
        pickupRef.current.getPlace();

     const address =
  `${place.name}, ${place.formatted_address}`;

      setPickupLocation(address);
      calculateDistance(address,dropoffLocation);
    }}
  >
    <Input
      type="text"
      placeholder="Enter pickup location"
      value={pickupLocation}
      onChange={(e)=>{
        setPickupLocation(e.target.value);
      }}
    />
  </Autocomplete>
) : (
  <Input
    type="text"
    placeholder="Loading Google pickup search..."
    value={pickupLocation}
    onChange={(e)=>{
      setPickupLocation(e.target.value);
    }}
  />
)}

          <LocationHint />

          {pickupSuggestions.length > 0 && (
            <SuggestionBox>
              {pickupSuggestions.map((place,index)=>(
                <SuggestionItem
                  key={index}
                  onClick={()=>{
                    setPickupLocation(place);
                    setPickupSuggestions([]);
                    calculateDistance(place,dropoffLocation);
                  }}
                >
                  {place}
                </SuggestionItem>
              ))}
            </SuggestionBox>
          )}
        </OrderSection>

        <OrderSection
          step="2"
          title="Dropoff Location"
        >
          {isLoaded ? (
 <Autocomplete
  options={{
    componentRestrictions:{
      country:"gh"
    },
    fields:[
      "formatted_address",
      "geometry",
      "name"
    ]
  }}
  onLoad={(autocomplete)=>{
    dropoffRef.current = autocomplete;
  }}
    onPlaceChanged={()=>{
      const place =
        dropoffRef.current.getPlace();

      const address =
  `${place.name}, ${place.formatted_address}`;

      setDropoffLocation(address);
      calculateDistance(
        pickupLocation,
        address
      );
    }}
  >
    <Input
      type="text"
      placeholder="Enter dropoff location"
      value={dropoffLocation}
      onChange={(e)=>{
        setDropoffLocation(e.target.value);
      }}
    />
  </Autocomplete>
) : (
  <Input
    type="text"
    placeholder="Loading Google dropoff search..."
    value={dropoffLocation}
    onChange={(e)=>{
      setDropoffLocation(e.target.value);
    }}
  />
)}

          <LocationHint />

          {dropoffSuggestions.length > 0 && (
            <SuggestionBox>
              {dropoffSuggestions.map((place,index)=>(
                <SuggestionItem
                  key={index}
                  onClick={()=>{
                    setDropoffLocation(place);
                    setDropoffSuggestions([]);
                    calculateDistance(pickupLocation,place);
                  }}
                >
                  {place}
                </SuggestionItem>
              ))}
            </SuggestionBox>
          )}
        </OrderSection>

        {dropoffCoords && (

  <div
    style={{
      marginBottom:"7px",
      borderRadius:"22px",
      overflow:"hidden",
      border:"1px solid rgba(29,78,216,0.14)",
      boxShadow:"0 12px 28px rgba(15,23,42,0.08)"
    }}
  >

    <div
      style={{
        background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
        color:"#facc15",
        padding:"12px 16px",
        fontWeight:"900"
      }}
    >
      Delivery Route Preview
    </div>

    <GoogleLiveMap
  pickupCoords={pickupCoords}
  dropoffCoords={dropoffCoords}
  mode="dropoff"
  availableRiders={availableRiders}
/>

  </div>
)}

        <OrderSection
          step="3"
          title="Item Notes"
        >
          <Input
            type="text"
            placeholder="Describe the item/package (optional)"
            value={itemNotes}
            onChange={(e)=>setItemNotes(e.target.value)}
          />
        </OrderSection>

        <div
          style={{
            background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
            border:"1px solid rgba(250,204,21,0.30)",
            borderRadius:"20px",
            padding:"15px",
            display:"flex",
            justifyContent:"space-between",
            alignItems:"center",
            marginTop:"16px",
            flexWrap:"wrap",
            gap:"14px",
            boxShadow:"0 12px 28px rgba(29,78,216,0.16)"
          }}
        >
          <FareItem
            label="Estimated Distance"
            value={`${distance || 0} KM`}
          />

          <FareItem
            label="Delivery Fee"
            value={`₵${amount || 0}`}
          />
        </div>

        <OrderSection
          step="4"
          title="Payment Option"
        >
          <div
            style={{
              display:"flex",
              gap:"12px",
              flexWrap:"wrap",
              marginTop:"12px"
            }}
          >
           <PayButton
  type="button"
  active={paymentMethod === "cash"}
  onClick={()=>setPaymentMethod("cash")}
>
              Cash on Delivery
            </PayButton>

            <PayButton
  type="button"
  active={paymentMethod === "momo"}
  onClick={()=>setPaymentMethod("momo")}
>
              Mobile Money
            </PayButton>
          </div>

          {paymentMethod === "momo" && (
            <div
              style={{
                marginTop:"14px",
                padding:"14px",
                borderRadius:"18px",
                background:"#eff6ff",
                border:"1px solid #dbeafe",
                boxShadow:"0 8px 18px rgba(29,78,216,0.08)"
              }}
            >
              <div
                style={{
                  fontSize:"13px",
                  fontWeight:"900",
                  color:"#1d4ed8",
                  marginBottom:"8px"
                }}
              >
                Mobile Money Number
              </div>

              <Input
                type="tel"
                placeholder="Enter MoMo number"
                value={momoNumber}
                onChange={(e)=>setMomoNumber(e.target.value)}
                style={{marginTop:"0"}}
              />

              <div
                style={{
                  marginTop:"8px",
                  fontSize:"12px",
                  fontWeight:"700",
                  color:"#64748b"
                }}
              >
                Use your active MTN MoMo number for payment confirmation.
              </div>
            </div>
          )}
        </OrderSection>

        <button
          type="button"
          onClick={()=>setShowConfirm(true)}
          onMouseEnter={(e)=>{
  e.currentTarget.style.transform =
    "translateY(-3px)";
  e.currentTarget.style.boxShadow =
    "0 14px 30px rgba(29,78,216,0.28)";
}}

onMouseLeave={(e)=>{
  e.currentTarget.style.transform =
    "translateY(0)";
  e.currentTarget.style.boxShadow =
    "0 12px 26px rgba(29,78,216,0.22)";
}}
          style={{
            width:"220px",
            border:"none",
            borderRadius:"16px",
            padding:"14px 18px",
            marginTop:"24px",
            background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
            color:"#facc15",
            fontSize:"15px",
            fontWeight:"900",
            cursor:"pointer",
            transition:"0.25s ease",
            touchAction:"manipulation",
            WebkitTapHighlightColor:"transparent",
            userSelect:"none",
            boxShadow:"0 12px 26px rgba(29,78,216,0.22)"
          }}
        >
          Create Order
        </button>
      </div>

</>
  );
}

function OrderSection({step,title,children}) {
  return (
    <div
      style={{
        background:"linear-gradient(135deg,#ffffff,#f8fafc)",
        borderRadius:"12px",
        padding:"9px",
        marginBottom:"10px",
        border:"1px solid rgba(29,78,216,0.10)",
        boxShadow:"0 8px 20px rgba(15,23,42,0.04)"
      }}
    >
      <div
        style={{
          display:"flex",
          alignItems:"center",
          gap:"14px",
          marginBottom:"10px"
        }}
      >
        <div
          style={{
            width:"28px",
            height:"28px",
            borderRadius:"12px",
            background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
            color:"#facc15",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            fontWeight:"900",
            fontSize:"15px"
          }}
        >
          {step}
        </div>

        <h3
          style={{
            fontSize:"16px",
            fontWeight:"900",
            color:"#0f172a",
            margin:0
          }}
        >
          {title}
        </h3>
      </div>

      {children}
    </div>
  );
}

function Input(props) {
  return (
    <input
      {...props}
      style={{
        width:"100%",
        padding:"11px 14px",
        borderRadius:"15px",
        border:"1px solid #dbe4ee",
        background:"white",
        fontSize:"15px",
        fontWeight:"600",
        outline:"none",
        color:"#0f172a",
        marginTop:"6px",
        boxSizing:"border-box",
        ...(props.style || {})
      }}
    />
  );
}

function LocationHint() {
  return (
    <div
      style={{
        display:"inline-flex",
        alignItems:"center",
        gap:"6px",
        marginTop:"4px",
        padding:"5px 8px",
        borderRadius:"999px",
        background:"#eff6ff",
        border:"1px solid #dbeafe",
        color:"#1d4ed8",
        fontSize:"12px",
        fontWeight:"800"
      }}
    >
      📍 House / Building, Street, Area, City
    </div>
  );
}

function SuggestionBox({children}) {
  return (
    <div
      style={{
        background:"#ffffff",
        border:"1px solid rgba(29,78,216,0.14)",
        borderRadius:"18px",
        marginTop:"10px",
        overflow:"hidden",
        boxShadow:"0 12px 26px rgba(15,23,42,0.08)"
      }}
    >
      {children}
    </div>
  );
}

function SuggestionItem({children,onClick}) {
  return (
    <div
      onClick={onClick}
      style={{
        padding:"13px 15px",
        cursor:"pointer",
        borderBottom:"1px solid #eef2ff",
        fontSize:"14px",
        fontWeight:"700",
        color:"#0f172a",
        background:"#ffffff"
      }}
    >
      {children}
    </div>
  );
}

function FareItem({label,value}) {
  return (
    <div>
      <div
        style={{
          color:"rgba(255,255,255,0.92)",
          fontSize:"14px",
          fontWeight:"900",
          letterSpacing:"0.4px",
          textTransform:"uppercase",
          marginBottom:"6px"
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize:"30px",
          fontWeight:"900",
          color:"#facc15",
          marginTop:"4px"
        }}
      >
        {value}
      </div>
    </div>
  );
}

function PayButton({children,active,onClick}) {
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={(e)=>{
        e.currentTarget.style.transform =
          "translateY(-3px)";
        e.currentTarget.style.boxShadow =
          "0 14px 30px rgba(29,78,216,0.28)";
      }}
      onMouseLeave={(e)=>{
        e.currentTarget.style.transform =
          "translateY(0)";
        e.currentTarget.style.boxShadow =
          "none";
      }}
      style={{
        borderRadius:"14px",
        padding:"12px 16px",
        border:active
          ? "2px solid #0f172a"
          : "1px solid rgba(29,78,216,0.25)",
        background:active
          ? "linear-gradient(135deg,#facc15,#f59e0b)"
          : "linear-gradient(135deg,#0f172a,#1d4ed8)",
        color:active ? "#0f172a" : "white",
        fontWeight:"900",
        cursor:"pointer",
        flex:1,
        transition:"0.25s ease"
      }}
    >
      {children}
    </button>
  );
}

function ConfirmRow({label,value}) {
  return (
    <div
      style={{
        background:"#f8fafc",
        border:"1px solid #e5e7eb",
        borderRadius:"13px",
        padding:"10px 12px",
        color:"#334155",
        fontWeight:"700",
        marginBottom:"10px"
      }}
    >
      <strong>{label}:</strong>{" "}
      {value}
    </div>
  );
}